export default __webpack_public_path__ + "static/media/banner1.908b8d9a.jpg";